import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { MarketdateStatus } from './marketdate-status.model';
import { MarketdateStatusPopupService } from './marketdate-status-popup.service';
import { MarketdateStatusService } from './marketdate-status.service';
import { Marketdate, MarketdateService } from '../marketdate';
import { User, UserService } from '../../shared';

@Component({
    selector: 'jhi-marketdate-status-dialog',
    templateUrl: './marketdate-status-dialog.component.html'
})
export class MarketdateStatusDialogComponent implements OnInit {

    marketdateStatus: MarketdateStatus;
    authorities: any[];
    isSaving: boolean;

    marketdates: Marketdate[];

    users: User[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private marketdateStatusService: MarketdateStatusService,
        private marketdateService: MarketdateService,
        private userService: UserService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['marketdateStatus', 'marketStatus']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.marketdateService.query().subscribe(
            (res: Response) => { this.marketdates = res.json(); }, (res: Response) => this.onError(res.json()));
        this.userService.query().subscribe(
            (res: Response) => { this.users = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.marketdateStatus.id !== undefined) {
            this.marketdateStatusService.update(this.marketdateStatus)
                .subscribe((res: MarketdateStatus) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        } else {
            this.marketdateStatusService.create(this.marketdateStatus)
                .subscribe((res: MarketdateStatus) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: MarketdateStatus) {
        this.eventManager.broadcast({ name: 'marketdateStatusListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    trackMarketdateById(index: number, item: Marketdate) {
        return item.id;
    }

    trackUserById(index: number, item: User) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-marketdate-status-popup',
    template: ''
})
export class MarketdateStatusPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private marketdateStatusPopupService: MarketdateStatusPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.marketdateStatusPopupService
                    .open(MarketdateStatusDialogComponent, params['id']);
            } else {
                this.modalRef = this.marketdateStatusPopupService
                    .open(MarketdateStatusDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-status/marketdate-status-dialog.component.ts